export default __webpack_public_path__ + "static/media/purple_firework_2.ac5e0295.jpg";